import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { NgForm } from '@angular/forms';
import { tap, filter, debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-carousel',
	templateUrl: './carousel.component.html',
	styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('carouselForm', { static: true }) carouselForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	carouselFormSubscription: Subscription;
	showList = true;
	frameError = new Array();
	imageError = new Array();
	isAdmin;

	constructor(private comService: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		if (!this.componentData.config.use_external) {
			this.componentData.config.use_external = {};
			this.componentData.config.use_external.image = false;
			this.componentData.config.use_external.add_image_tracking = false;
			this.componentData.config.use_external.link = false;
			this.componentData.config.use_external.add_link_tracking = false;
		}

		this.isAdmin = this.auth.isAdmin();
		this.carouselFormSubscription = this.carouselForm.valueChanges
			.pipe(
				tap(() => {
					this.comService.updateDisabledSave(
						(this.carouselForm.dirty && this.carouselForm.invalid) || this.nameField.editComponentName
					);
					this.comService.updateComponentData(this.componentData);
					if (this.carouselForm.invalid) {
						for (var i = 0; i < this.componentData.config.count; i++) {
							if (typeof this.carouselForm.controls['link' + i] !== 'undefined') {
								if (this.carouselForm.controls['link' + i].invalid) {
									this.imageError[i] = 1;
								} else {
									this.imageError[i] = 0;
								}
							} else {
								this.imageError[i] = 1;
							}
						}
						for (var j = 0; j < this.componentData.config.count / this.componentData.config.items_per_frame; j++) {
							this.frameError[j] = 0;
							for (var k = 0; k < this.componentData.config.items_per_frame; k++) {
								this.frameError[j] += this.imageError[j * this.componentData.config.items_per_frame + k];
							}
						}
					}
				}),
				filter((form) => this.carouselForm.dirty && this.carouselForm.valid),
				debounceTime(1000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.carouselFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		if (this.componentData.config.gif_fallback) {
			this.comService.updatePreviewData();
		} else {
			const html = `<style>` + this.getInstantViewerCSS() + `</style>` + this.getInstantViewerHTML();
			// + this.getInstantViewerHTMLFallback();

			this.comService.updatePreviewContent(html);
		}
		this.comService.updatePreviewData();
	}

	getInstantViewerCSS() {
		let css = '';
		const num_of_frames = this.componentData.config['count'] / this.componentData.config['items_per_frame'];

		const width =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['item_width']
				: this.componentData.config['items_per_frame'] * this.componentData.config['item_width'];

		const height =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['items_per_frame'] * this.componentData.config['item_height']
				: this.componentData.config['item_height'];

		const direction = this.componentData.config['animation_type'] === 'vertical' ? 'top' : 'right';
		const directionPrefix = this.componentData.config['animation_type'] === 'vertical' ? '-' : '';
		const directionPrefix2 = this.componentData.config['animation_type'] === 'vertical' ? '' : '-';
		const amountToMove = this.componentData.config['animation_type'] === 'vertical' ? height : width;

		if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
			css +=
				`.slider_dynamic.widget div { background:#fff; width: ` +
				width +
				`px; height: ` +
				height +
				`px; position: absolute !important; ` +
				direction +
				`: -` +
				width +
				`px; list-style: none; top:0; }  /* dimension of each layer */`;
			css +=
				`.slider_dynamic.widget { width: ` +
				width +
				`px; height: ` +
				height +
				`px !important; max-height: ` +
				height +
				`px !important; margin: 0 auto; overflow: hidden; position: relative;}  /* dimension of content */
              .slider_dynamic.widget div table { background:#fff; margin: 0; padding: 0; position: relative; height: ` +
				height +
				`px;}
              .slider_dynamic.widget div img{ vertical-align: middle; float:left;}
              .slider_dynamic.widget div a{float:left;}
              .slider_frame { max-height:` +
				height +
				`px !important;}`;
		} else {
			css += '.slider_dynamic_wrap {height: auto !important; max-height: 100% !important;}';
		}
		if (this.componentData.config['scroll_type'] === 'ticker') {
			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				for (let i = 0; i < num_of_frames; i++) {
					css +=
						'.slider_dynamic.widget #slide_num_' +
						(i + 1) +
						' { animation: cycle' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; -webkit-animation: cycle' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; }';

					css += ' @-webkit-keyframes cycle' + (i + 1) + '_widget {';

					const this_precent = 100 / num_of_frames;
					let value;
					for (let j = 0; j <= num_of_frames; j++) {
						if (j < i) {
							value = directionPrefix2 + amountToMove + 'px';
						} else if (j > i) {
							value = directionPrefix + amountToMove + 'px';
						} else {
							value = 0;
						}
						// Restart the loop
						if (i === 0 && j === num_of_frames - 1 && num_of_frames !== 2) {
							value = directionPrefix2 + amountToMove + 'px';
						}
						if (i === 0 && j === num_of_frames) {
							value = 0;
						}

						css += j * this_precent + '% {' + direction + ': ' + value + '}';

						if (i === 0 && num_of_frames === 2 && j === 1) {
							css += '50.09% {' + direction + ': ' + directionPrefix2 + amountToMove + 'px;}';
							css += '51% {' + direction + ': ' + directionPrefix2 + (amountToMove - amountToMove * 0.02) + 'px;}';
						}
					}
					css += '}';

					css += ' @keyframes cycle' + (i + 1) + '_widget {';

					for (let j = 0; j <= num_of_frames; j++) {
						if (j < i) {
							value = directionPrefix2 + amountToMove + 'px';
						} else if (j > i) {
							value = directionPrefix + amountToMove + 'px';
						} else {
							value = 0;
						}
						// Restart the loop
						if (i === 0 && j === num_of_frames - 1 && num_of_frames !== 2) {
							value = directionPrefix2 + amountToMove + 'px';
						}
						if (i === 0 && j === num_of_frames) {
							value = 0;
						}

						css += j * this_precent + '% {' + direction + ': ' + value + '}';

						if (i === 0 && num_of_frames === 2 && j === 1) {
							css += '50.09% {' + direction + ': ' + directionPrefix2 + amountToMove + 'px;}';
							css += '51% {' + direction + ': ' + directionPrefix2 + (amountToMove - amountToMove * 0.02) + 'px;}';
						}
					}

					css += '}';
				}
			} else {
				const amountToMove3 = 100 / num_of_frames + '%';
				for (let i = 0; i < num_of_frames; i++) {
					css +=
						'.widget .slider .control-' +
						(i + 1) +
						' { animation: control_' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; -webkit-animation: control_' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; }';
					css += ' @-webkit-keyframes control_' + (i + 1) + '_widget {';
					const this_precent = 100 / num_of_frames;
					let value;

					for (let j = 0; j <= num_of_frames; j++) {
						if (j < i) {
							value = directionPrefix2 + amountToMove3;
						} else if (j > i) {
							value = directionPrefix + amountToMove3;
						} else {
							value = 0;
						}
						// Restart the loop
						if (i === 0 && j === num_of_frames - 1 && num_of_frames !== 2) {
							value = directionPrefix2 + amountToMove3;
						}
						if (i === 0 && j === num_of_frames) {
							// last cell on first row
							value = 0;
						}
						if (i === 0) {
							css += j * this_precent + '% {' + direction + ': ' + value + '}';

							if (i === 0 && num_of_frames === 2 && j === 1) {
								css += '50.09% {' + direction + ': ' + directionPrefix2 + amountToMove3 + '}';
								css += '51% {' + direction + ': ' + directionPrefix2 + (+amountToMove3 - 1) + '%}';
							}
						} else {
							css += j * this_precent + '% {' + direction + ': ' + j * this_precent + '%}';
						}
					}
					css += '}';

					css += ' @keyframes control_' + (i + 1) + '_widget {';
					for (let j = 0; j <= num_of_frames; j++) {
						if (j < i) {
							value = directionPrefix2 + amountToMove3;
						} else if (j > i) {
							value = directionPrefix + amountToMove3;
						} else {
							value = 0;
						}
						// Restart the loop
						if (i === 0 && j === num_of_frames - 1 && num_of_frames !== 2) {
							value = directionPrefix2 + amountToMove3;
						}
						if (i === 0 && j === num_of_frames) {
							value = 0;
						}

						if (i === 0) {
							css += j * this_precent + '% {' + direction + ': ' + value + '}';

							if (i === 0 && num_of_frames === 2 && j === 1) {
								css += '50.09% {' + direction + ': ' + directionPrefix2 + amountToMove3 + '}';
								css += '51% {' + direction + ': ' + directionPrefix2 + (+amountToMove3 - 1) + '%}';
							}
						} else {
							css += j * this_precent + '% {' + direction + ': ' + j * this_precent + '%}';
						}
					}
					css += '}';
				}
			}
		} else if (this.componentData.config['scroll_type'] === 'stripe') {
			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				for (let i = 0; i < num_of_frames; i++) {
					css +=
						'.slider_dynamic.widget #slide_num_' +
						(i + 1) +
						' { animation: cycle' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; -webkit-animation: cycle' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; }';

					css += ' @-webkit-keyframes cycle' + (i + 1) + '_widget {';
					if (i === 0) {
						css += '0% {' + direction + ': 0 }';
					} else {
						css += '0% {' + direction + ': ' + directionPrefix2 + amountToMove + 'px}';
					}

					let value, value2;
					for (let j = 0; j < num_of_frames; j++) {
						if (j === i) {
							value2 = directionPrefix + amountToMove + 'px';
							value = '0';
						} else if (i - 1 === j) {
							value2 = '0';
							value = directionPrefix2 + amountToMove + 'px';
						} else if (i === 0 && j === num_of_frames - 1) {
							value2 = '0';
							value = directionPrefix2 + amountToMove + 'px';
						} else {
							value2 = directionPrefix2 + amountToMove + 'px';
							value = directionPrefix2 + amountToMove + 'px';
						}

						css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + value + '}';
						css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + value2 + '}';
					}

					css += '}';

					css += ' @keyframes cycle' + (i + 1) + '_widget {';
					if (i === 0) {
						css += '0% {' + direction + ': 0 }';
					} else {
						css += '0% {' + direction + ': ' + directionPrefix2 + amountToMove + 'px}';
					}

					for (let j = 0; j < num_of_frames; j++) {
						if (j === i) {
							value2 = directionPrefix + amountToMove + 'px';
							value = '0';
						} else if (i - 1 === j) {
							value2 = '0';
							value = directionPrefix2 + amountToMove + 'px';
						} else if (i === 0 && j === num_of_frames - 1) {
							value2 = '0';
							value = directionPrefix2 + amountToMove + 'px';
						} else {
							value2 = directionPrefix2 + amountToMove + 'px';
							value = directionPrefix2 + amountToMove + 'px';
						}

						css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + value + '}';
						css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + value2 + '}';
					}

					css += '}';
				}
			} else {
				const amountToMove2 = 100 / num_of_frames + '%';
				for (let i = 0; i < num_of_frames; i++) {
					css +=
						'.widget .slider .control-' +
						(i + 1) +
						' { animation: control_' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; -webkit-animation: control_' +
						(i + 1) +
						'_widget ' +
						this.componentData.config['speed'] +
						's linear infinite; }';

					css += '@-webkit-keyframes control_' + (i + 1) + '_widget {';
					css += '0% {' + direction + ': 0 }';

					let value, value2;
					for (let j = 0; j < num_of_frames; j++) {
						if (j === i) {
							value2 = directionPrefix + amountToMove2;
							value = '0';
						} else if (i - 1 === j) {
							value2 = '0';
							value = directionPrefix2 + amountToMove2;
						} else if (i === 0 && j === num_of_frames - 1) {
							value2 = '0';
							value = directionPrefix2 + amountToMove2;
						} else {
							value2 = directionPrefix2 + amountToMove2;
							value = directionPrefix2 + amountToMove2;
						}
						if (i === 0) {
							css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + value + '}';
							css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + value2 + '}';
						} else {
							css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + (j * 100) / num_of_frames + '%}';
							css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + ((j + 1) * 100) / num_of_frames + '%}';
						}
					}

					css += '}';

					css += ' @keyframes control_' + (i + 1) + '_widget {';
					css += '0% {' + direction + ': 0 }';

					for (let j = 0; j < num_of_frames; j++) {
						if (j === i) {
							value2 = directionPrefix + amountToMove2;
							value = '0';
						} else if (i - 1 === j) {
							value2 = '0';
							value = directionPrefix2 + amountToMove2;
						} else if (i === 0 && j === num_of_frames - 1) {
							value2 = '0';
							value = directionPrefix2 + amountToMove2;
						} else {
							value2 = directionPrefix2 + amountToMove2;
							value = directionPrefix2 + amountToMove2;
						}
						if (i === 0) {
							css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + value + '}';
							css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + value2 + '}';
						} else {
							css += ((j + 1) * 100) / num_of_frames - 4 + '% {' + direction + ': ' + (j * 100) / num_of_frames + '%}';
							css += ((j + 1) * 100) / num_of_frames + '% {' + direction + ': ' + ((j + 1) * 100) / num_of_frames + '%}';
						}
					}

					css += '}';
				}
			}
		}
		return css;
	}

	// TODO: Decide with Shefa what the Behavior will be with new fallback
	getInstantViewerHTMLFallback() {
		const fluid_frame_width = 100 / this.componentData.config['items_per_frame'];
		const num_of_frames = +this.componentData.config['count'] / +this.componentData.config['items_per_frame'];
		const theClass = this.componentData.config['animation_type'] === 'vertical' ? 'vertical' : 'horizontal';
		const width =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['item_width']
				: this.componentData.config['items_per_frame'] * this.componentData.config['item_width'];
		const height =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['items_per_frame'] * this.componentData.config['item_height']
				: this.componentData.config['item_height'];

		let html = '<!--Fallback -->';
		if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
			html +=
				'<table dir="ltr" cellpadding="0" cellspacing="0" width="' +
				width +
				'" ' +
				'height="' +
				height +
				'" class="fallback" id="fallback_' +
				theClass +
				' fallback_widget" style="display: none;">';
		} else {
			html +=
				'<table dir="ltr" cellpadding="0" cellspacing="0" width="100%" class="fallback slider_fallback_fluid" ' +
				'id="fallback_' +
				theClass +
				' fallback_widget" style="mso-hide:all; display: none;">';
		}
		if (this.componentData.config['animation_type'] !== 'vertical') {
			html += '<tr>';
		}
		let item_num;
		for (let j = 1; j <= +this.componentData.config['items_per_frame']; j++) {
			if (this.componentData.config['animation_type'] === 'vertical') {
				html += '<tr>';
			}
			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				html += '<td style="font-size: 0;">'; // for outlook.com and outlook desktop
			} else {
				html += '<td style="font-size: 0; width:' + fluid_frame_width + '%">'; // for outlook.com and outlook desktop
			}
			item_num = j - 1;

			//   //gadi-start
			//   if (this.componentData.config['gif_fallback']) && this.componentData.config['gif_fallback'])
			//   $link = (this.componentData.config['gif_fallback_link'] && $this->validURL(this.componentData.config['gif_fallback_link']))
			// ? this.componentData.config['gif_fallback_link'] . '?position=' . ($item_num + 1) : '';
			// else
			//   //gadi-end
			const link = this.componentData.config.items[item_num].link;
			let theStyle;
			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				theStyle =
					`style="display:block; max-height:` +
					this.componentData.config.item_height +
					`px; height:` +
					this.componentData.config.item_height +
					`px;"`;
			} else {
				theStyle = `style="display:block; width:100%;"`;
			}
			if (link) {
				html += ' <a href="' + link + '"  target="_blank" ' + theStyle + '> ';
			}

			//   //gadi-start
			//   if (isset(this.componentData.config['gif_fallback']) && this.componentData.config['gif_fallback'])
			//   $image_url = $this->getServer(true, true) . $row['directory'] . 'ribbon_image_' . $j . '.gif?_=' . time();
			// else
			//   //gadi-end
			const image_url = this.componentData.config.items[item_num].imageURL;

			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				html +=
					'<img src="' +
					image_url +
					'" width="' +
					this.componentData.config.item_width +
					'" ' +
					'height="' +
					this.componentData.config.item_height +
					'" style="display:block; ' +
					'max-height:' +
					this.componentData.config.item_height +
					'px;height:' +
					this.componentData.config.item_height +
					'px;"/>';
			} else {
				html += '<img src="' + image_url + '" width="100%" style="display:block; width:100%;"/>';
			}
			if (link) {
				html += '</a> ';
			}

			html += '</td>';
			if (this.componentData.config['animation_type'] === 'vertical') {
				html += '</tr>';
			}
		}
		if (this.componentData.config['animation_type'] !== 'vertical') {
			html += '<tr>';
		}
		html += '</table>';
		if (this.componentData.config['responsive_type'] === 'fluid' || this.componentData.config['responsive'] === 1) {
			html += '<!--<![endif]-->';
		}
		html += `<!-- //outlook web fix -->
        <style>
          .fallback td div, .fallback td div button {
            display: block !important;
            width: 100%;
          }
      </style>
      <!-- /Fallback-->`;
		return html;
	}

	getInstantViewerHTML() {
		let html = '';
		const num_of_frames = this.componentData.config['count'] / this.componentData.config['items_per_frame'];
		const directionClass = this.componentData.config['animation_type'] === 'vertical' ? 'vertical' : 'horizontal';

		const width =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['item_width']
				: this.componentData.config['items_per_frame'] * this.componentData.config['item_width'];
		const height =
			this.componentData.config['animation_type'] === 'vertical'
				? this.componentData.config['items_per_frame'] * this.componentData.config['item_height']
				: this.componentData.config['item_height'];

		if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
			html +=
				`<table class="slider_dynamic widget" id="dm_dynamic_` +
				directionClass +
				`"
                  cellpadding="0" cellspacing="0" width="` +
				width +
				`" height="` +
				height +
				`"><tr><td>`;
		} else {
			html +=
				`
        <div class="slider_dynamic_wrap" style="width: 100%; overflow: hidden;">
          <table class="slider_dynamic widget" id="dm_dynamic_` +
				directionClass +
				`" cellpadding="0" cellspacing="0" width="100%"><tr><td>
          <div class="slider" style="font-size:0; position: relative; left: 0; width:` +
				100 * num_of_frames +
				`%;">`;
		}

		for (let i = 0; i < num_of_frames; i++) {
			if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
				html +=
					`<div class="control-` +
					(i + 1) +
					` slider_frame" id="slide_num_` +
					(i + 1) +
					`" width="` +
					width +
					`"
                  style="background: #fff; width: ` +
					width +
					`px; position: relative; float: left; max-height:0; overflow: hidden;">`;
			} else {
				html +=
					`<div class="control-` +
					(i + 1) +
					`" id="slide_num_` +
					(i + 1) +
					`"
                    width="100%" style="background: #fff; width: ` +
					100 / num_of_frames +
					`%; position: relative; float: left;">`;
			}
			html += `<table width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td>`;

			for (let j = 1; j <= this.componentData.config['items_per_frame']; j++) {
				const item_num = i * this.componentData.config['items_per_frame'] + j - 1;
				const link = this.componentData.config.items[item_num]['link'];
				const image_url = this.componentData.config.items[item_num]['imageURL'];
				let imageWidth, imageHeight;

				if (this.componentData.config['responsive_type'] === 'fixed' || this.componentData.config['responsive'] === 0) {
					imageWidth =
						this.componentData.config['animation_type'] === 'vertical'
							? width + 'px'
							: width / this.componentData.config['items_per_frame'] + 'px';
					imageHeight =
						this.componentData.config['animation_type'] !== 'vertical'
							? height + 'px'
							: height / this.componentData.config['items_per_frame'] + 'px';
				} else {
					imageWidth = 100 / this.componentData.config['items_per_frame'] + '%';
					imageHeight = 'auto';
				}
				if (link) {
					html += `<a href="` + link + `" target="_blank">`;
				}
				html +=
					`<img src="` +
					image_url +
					`"
            style="width:` +
					imageWidth +
					`; height:` +
					imageHeight +
					`; vertical-align:top; float:left;" class="image_` +
					item_num +
					`"/>`;
				if (link) {
					html += `</a>`;
				}
			}
			html += `</td>
            </tr>
          </table>
        </div>`;
		}
		if (this.componentData.config['responsive_type'] === 'fluid' || this.componentData.config['responsive'] === 1) {
			html += '</div>';
		}
		html += `</td>
          </tr>
        </table>`;

		if (this.componentData.config['responsive_type'] === 'fluid' || this.componentData.config['responsive'] === 1) {
			html += '</div>';
		}
		return html;
	}

	createRange(number) {
		const items: number[] = [];
		for (let i = 1; i <= number; i++) {
			items.push(i);
		}
		return items;
	}

	removeFrame() {
		this.componentData.config.count = +this.componentData.config.count - +this.componentData.config.items_per_frame;
	}

	addFrame() {
		this.componentData.config.count = Math.min(+this.componentData.config.count + +this.componentData.config.items_per_frame, 12);
	}

	checkFallbackOption() {
		if (this.componentData.config.use_external.image == true) {
			this.componentData.config.gif_fallback = false;
		}
		if (
			this.componentData.config.use_external.image == true &&
			this.componentData.config.version > 1 &&
			!this.componentData.config.external_fallback
		) {
			let data = [];
			for (let i = 0; i < this.componentData.config.items_per_frame; i++) {
				data[i] = {
					imageURL: '',
					link: ''
				};
			}
			this.componentData.config.external_fallback = data;
		}
	}

	refreshList() {
		this.showList = false;
		setTimeout(() => {
			this.showList = true;
			document.getElementById('speedOfStripe').focus();
		});
		if (
			this.componentData.config.version > 1 &&
			this.componentData.config.use_external.image == true &&
			this.componentData.config.external_fallback.length < this.componentData.config.items_per_frame
		) {
			for (let i = this.componentData.config.external_fallback.length; i < this.componentData.config.items_per_frame; i++) {
				this.componentData.config.external_fallback[i] = {
					imageURL: '',
					link: ''
				};
			}
		}
	}
}
